import React from "react";
import { Input } from "reactstrap";
import "./style.css";
import { Button, Drawer, Table } from "antd";
import DrawerTable from "./drawerTable";
import XslxGen from "../xslx";
import { Menu, Dropdown } from "antd";
import Icon from "@ant-design/icons";
import { Row, Col } from "antd";

export default class MedTable extends React.Component {
  state = {
    searchField: "",
    currentSelectedUser: [],
    visible: false,
    batch35: [],
    batch36: [],
    batch37: [],
    batch38: [],
    TempVal: [],
    selectedRow: "",
    columns: [
      {
        title: "Name",
        width: "18%",
        key: "Name",
        dataIndex: "name",
      },
      {
        title: "Email",
        dataIndex: "email",
        width: "13%",
        key: "Email",
      },
      {
        title: "Courses Completed",
        width: "20%",
        key: "courseCompleted",
        render: (record) => <p>{record.courseCompleted.length}</p>,
      },
    ],
  };

  handleSearchChange = (event) => {
    this.setState({ searchField: event.target.value });
  };

  showDrawer = (record) => {
    this.setState({
      visible: true,
      selectedRow: record.courseCompleted,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  filterData35 = () => {
    const { users } = this.props;

    this.state.batch35 = users.filter((user) => {
      return user.usertype === "Agent" && user.batch === 35 ? users : null;
    });
    this.setState({ batch35: this.state.batch35, TempVal: 35 });

    // console.log("agenside", this.state.batch35);

    // console.log("user data...", this.state.batch35);
  };
  filterData36 = () => {
    const { users } = this.props;

    this.state.batch36 = users.filter((user) => {
      return user.usertype === "Agent" && user.batch === 36 ? users : null;
    });
    this.setState({ batch36: this.state.batch36, TempVal: 36 });
    // console.log("agenside", this.state.batch35);

    // console.log("user data...", this.state.batch35);
  };
  filterData37 = () => {
    const { users } = this.props;

    this.state.batch37 = users.filter((user) => {
      return user.usertype === "Agent" && user.batch === 37 ? users : null;
    });
    this.setState({ batch37: this.state.batch37, TempVal: 37 });
    // console.log("agenside", this.state.batch35);

    // console.log("user data...", this.state.batch35);
  };
  filterData38 = () => {
    const { users } = this.props;

    this.state.batch38 = users.filter((user) => {
      return user.usertype === "Agent" && user.batch === 38 ? users : null;
    });
    this.setState({ batch38: this.state.batch38, TempVal: 38 });
    // console.log("agenside", this.state.batch35);

    // console.log("user data...", this.state.batch35);
  };

  render() {
    const { batch35, batch36, batch37, batch38 } = this.state;
    const { searchField } = this.state;
    const { users } = this.props;

    const filteredUsers = users.filter((user) => {
      return user.usertype === "Agent" && user.courseCompleted.length === 0
        ? user.name.toLowerCase().includes(searchField.toLowerCase())
        : null;
    });
    const menu = (
      <Menu>
        <Menu.Item key="0">
          <Button
            className="mButton"
            style={{ marginRight: 8 }}
            onClick={this.filterData35}
          >
            Batch 35
          </Button>
        </Menu.Item>

        <Menu.Item key="1">
          <Button
            className="mButton"
            style={{ marginRight: 8 }}
            onClick={this.filterData36}
          >
            Batch 36
          </Button>
        </Menu.Item>
        <Menu.Item key="2">
          <Button
            className="mButton"
            style={{ marginRight: 8 }}
            onClick={this.filterData37}
          >
            Batch 37
          </Button>
        </Menu.Item>
        <Menu.Item key="2">
          <Button
            className="mButton"
            style={{ marginRight: 8 }}
            onClick={this.filterData38}
          >
            Batch 38
          </Button>
        </Menu.Item>
      </Menu>
    );

    return (
      <div className="MesdTable">
        <div>
          <Row
            style={{
              marginRight: "20px",
            }}
          >
            <Col span={4}>
              {" "}
              <XslxGen csvData={filteredUsers} fileName={"Dead Agents"} />
            </Col>
            <Col span={5}>
              <Dropdown overlay={menu} trigger={["click"]}>
                <a className="userButton" href="#">
                  <b>Filter By Batch</b> <Icon type="down" />
                </a>
              </Dropdown>
            </Col>
            <Col span={4}>
              <div className="userButton">
                {(() => {
                  switch (this.state.TempVal) {
                    case 35:
                      return "Batch35  (" + batch35.length + ")";
                    case 36:
                      return "Batch36  (" + batch36.length + ")";
                    case 37:
                      return "Batch37  (" + batch37.length + ")";
                    case 38:
                      return "Batch38  (" + batch38.length + ")";
                    default:
                  }
                })()}
              </div>
            </Col>
            <Col span={7} />
            <Col span={4}>
              <Input
                className="input"
                placeholder="Search by Name.."
                onChange={this.handleSearchChange}
                type="search"
              />
            </Col>
          </Row>
          <br />
          <Row>
            <div>
              {(() => {
                switch (this.state.TempVal) {
                  case 35:
                    return (
                      <div className="TableScrollbar">
                        <Table
                          bordered
                          dataSource={this.state.batch35}
                          columns={this.state.columns}
                          scroll={{ y: 650 }}
                          pagination={false}
                        />
                      </div>
                    );
                  case 36:
                    return (
                      <div className="TableScrollbar">
                        <Table
                          bordered
                          dataSource={this.state.batch36}
                          columns={this.state.columns}
                          scroll={{ y: 650 }}
                          pagination={false}
                        />
                      </div>
                    );
                  case 37:
                    return (
                      <div className="TableScrollbar">
                        <Table
                          bordered
                          dataSource={this.state.batch37}
                          columns={this.state.columns}
                          scroll={{ y: 650 }}
                          pagination={false}
                        />
                      </div>
                    );
                  case 38:
                    return (
                      <div className="TableScrollbar">
                        <Table
                          bordered
                          dataSource={this.state.batch38}
                          columns={this.state.columns}
                          scroll={{ y: 650 }}
                          pagination={false}
                        />
                      </div>
                    );
                  default:
                    return (
                      <div className="TableScrollbar">
                        <Table
                          bordered
                          dataSource={filteredUsers}
                          columns={this.state.columns}
                          scroll={{ y: 650 }}
                          pagination={false}
                        />
                      </div>
                    );
                }
              })()}
            </div>
          </Row>{" "}
        </div>
        <Drawer
          title="Agent Progress Drawer"
          width={window.innerWidth > 500 ? 840 : window.innerWidth - 150}
          onClose={this.onClose}
          visible={this.state.visible}
          style={{ backgroundColor: "#0000008a" }}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <Button className="mButton" onClick={this.onClose}>
                Close
              </Button>
            </div>
          }
        >
          <DrawerTable selectedRow={this.state.selectedRow} />
        </Drawer>
      </div>
    );
  }
}
